import { FAKE_USER_ID_PREFIX } from '../../../constants';
import { Configuration } from '../../Configuration';
import { SocketType } from '../../SocketType';
import { ConfigurationCodeMapper } from '../ConfigurationCodeMapper';
import { ArticlePersistenceMapper } from './ArticlePersistenceMapper';
import { RequiredArticlePersistenceMapper } from './RequiredArticlePersistenceMapper';
import { SlotPersistenceMapper } from './SlotPersistenceMapper';
import { ThemePersistenceMapper } from './ThemePersistenceMapper';

export class ConfigurationPersistenceMapper {
  public static toDto = (
    configuration: Configuration,
  ): SimpleProjectServiceAPI.ConfigurationDataDto => {
    const persistableConfiguration = ConfigurationPersistenceMapper.toPersistableConfiguration(
      configuration,
    );

    return {
      root: persistableConfiguration.root,
      storeId: persistableConfiguration.id,
      articles: persistableConfiguration.articles.map(ArticlePersistenceMapper.toDto),
      slots: persistableConfiguration.slots.map(SlotPersistenceMapper.toDto),
      requiredConnectArticles: persistableConfiguration.requiredConnectArticles.map(
        RequiredArticlePersistenceMapper.toDto,
      ),
      requiredLightingArticles: persistableConfiguration.requiredLightingArticles.map(
        RequiredArticlePersistenceMapper.toDto,
      ),
      rootArticleName: configuration.readableRootArticleName(),
      socketType: configuration.socketType,
      theme: ThemePersistenceMapper.toDto(configuration.theme),
      version: configuration.version,
      fakeUserId: configuration.creator?.startsWith(FAKE_USER_ID_PREFIX)
        ? configuration.creator
        : null,
      creatorId: !configuration.creator?.startsWith(FAKE_USER_ID_PREFIX)
        ? configuration.creator
        : null,
      configurationCode:
        configuration.configurationCode &&
        ConfigurationCodeMapper.toDto(configuration.configurationCode),
      createdSessionId: configuration.createdSessionId,
    };
  };

  public static toDomain = (dto: SimpleProjectServiceAPI.ConfigurationDataDto): Configuration => {
    return new Configuration(
      dto.root,
      dto.articles.map(ArticlePersistenceMapper.toDomain),
      dto.slots.map(SlotPersistenceMapper.toDomain),
      dto.storeId,
      dto.requiredConnectArticles.map(RequiredArticlePersistenceMapper.toDomain),
      dto.requiredLightingArticles.map(RequiredArticlePersistenceMapper.toDomain),
      dto.creatorId || dto.fakeUserId,
      SocketType[dto.socketType],
      ThemePersistenceMapper.toDomain(dto.theme),
      dto.version,
      dto.configurationCode && ConfigurationCodeMapper.toDomain(dto.configurationCode),
      dto.createdSessionId,
    );
  };

  static toPersistableConfiguration = (configuration: Configuration) => {
    const removeDefinitions = (article) => {
      const colors = article.colors.map((color) => ({ ...color, definition: undefined }));
      return { ...article, definition: article.definition, colors };
    };

    return {
      ...configuration,
      articles: configuration.articles.map(removeDefinitions),
      requiredLightingArticles: configuration.requiredLightingArticles.map(removeDefinitions),
      requiredConnectArticles: configuration.requiredConnectArticles.map(removeDefinitions),
    };
  };
}
